import React from 'react'
import './dropDown.css'
export default function DropDowwn() {
    return (
        <div className='drop-container'>
            <ul>
                <li>
                    <i className='bx bx-category'></i>
                    <p>Personalized Insights</p>
                </li>
                <li>
                    <i className='bx bxs-check-shield' ></i>
                    <p>Smart Savings</p>
                </li>
                <li>
                    <i className='bx bxs-share' ></i>
                    <p>Instant Transfers</p>
                </li>
            </ul>
        </div>
    )
}
